import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_KEY_STORAGE = "rescue_admin_key";

export const getAdminKey = () => localStorage.getItem(ADMIN_KEY_STORAGE) || "";
export const setAdminKey = (k) => localStorage.setItem(ADMIN_KEY_STORAGE, k);
export const clearAdminKey = () => localStorage.removeItem(ADMIN_KEY_STORAGE);

export const createRequest = async (payload) => {
  const { data } = await axios.post(`${API}/requests`, payload);
  return data;
};

export const createInsuranceLead = async (payload) => {
  const { data } = await axios.post(`${API}/insurance-leads`, payload);
  return data;
};

export const adminLogin = async (passcode) => {
  const { data } = await axios.post(`${API}/admin/login`, { passcode });
  return data;
};

const authHeaders = () => ({ headers: { "X-Admin-Key": getAdminKey() } });

export const fetchRequests = async (status = "all") => {
  const { data } = await axios.get(`${API}/requests`, {
    ...authHeaders(),
    params: { status },
  });
  return data;
};

export const fetchStats = async () => {
  const { data } = await axios.get(`${API}/stats`, authHeaders());
  return data;
};

export const updateRequestStatus = async (id, status) => {
  const { data } = await axios.patch(`${API}/requests/${id}/status`, { status }, authHeaders());
  return data;
};
